"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.scrubTelemetryData = void 0;

var scrubTelemetryData = function scrubTelemetryData(payload) {
  return (payload === null || payload === void 0 ? void 0 : payload.replace(/Bearer [A-Za-z0-9-_=.]+/, '<Scrubbed JWT token>')) || '';
};

exports.scrubTelemetryData = scrubTelemetryData;